import { left, right, map } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/lib/function';
import { useEffect, useState } from 'react';
import { useSignupFlow } from '.';
import { useQuery } from '../common';

// code: '' is for not-sign-up
// code: not empty string is for sign-up
export function useSignup() {
  let query = useQuery();

  const signupFlow = useSignupFlow();

  const [code, setCode] = useState('');

  useEffect(() => {
    const handleSubmit = flow(
      query.get.bind(query),
      code => (code !== null && signupFlow ? right(code as string) : left('')),
      map(setCode)
    );

    handleSubmit('code');
  }, [query, signupFlow]);

  return code;
}
